<template>
<keep-alive>
  <div class="box">
    <headTop></headTop>
    <div class="flex">
      <leftNav></leftNav>
      <div v-if="$route.path!='/'" class="bg">
        <!-- 预留链接 -->
        <!-- <div>
          <el-tabs type="border-card"></el-tabs>
        </div> -->
        <router-view class="view"></router-view>
      </div>
      <div v-else class="welc">
          欢迎使用服务分包管理系统
      </div>
    </div>
  </div>
</keep-alive>
</template>

<script>
// @ is an alias to /src
import leftNav from '@/components/leftNav.vue'
import headTop from '@/components/Head.vue'
import {GetUser} from '@/api/login'
export default {
  name: 'HomeView',
  components: {
    leftNav,headTop
  },
  data(){
    return{
      list:[]
    }
  },
  computed(){
  },
  created(){
    
    var token = window.localStorage.getItem('token');
    
    GetUser(token).then(res=>{
      if(res.status === 200){
        this.$store.commit('login/updateUser',res.data)
        console.log(this.$store.state.login.user)
      }
    })
  }
}
</script>
<style scoped>
.box{
  box-sizing: border-box;
}
.flex{
  display:flex;
}
.welc{
  font-size: 50px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  margin-left: 100px;
}
.bg{
  width: 85%;
  max-height: 80%;
  overflow: hidden;
}
.view{
  padding:0 50px;
}
</style>
